import { useState, useEffect } from 'react';

export const useGoldPrice = () => {
  const [prices, setPrices] = useState({ 
    gold: 0, silver: 0, forex: [], rates: {}, 
    goldHigh: 0, goldLow: 0, silverHigh: 0, silverLow: 0,
    change: "+0.00%", amount: "$0.00"
  });

  const fetchPrices = async () => {
    try {
      const API_KEY = "43485b8770d893c7437c8b0a1bd622a3";
      const url = `https://api.metalpriceapi.com/v1/latest?api_key=${API_KEY}&base=USD`;

      const response = await fetch(url);
      const data = await response.json();

      if (data && data.rates) {
        const r = data.rates;
        
        // قراءة السعر كما يرسله الـ API تماماً (4700 دولار للأونصة)
        const currentGold = parseFloat((1 / r.XAU).toFixed(2));
        const currentSilver = parseFloat((1 / r.XAG).toFixed(2));

        setPrices({
          gold: currentGold,
          goldHigh: (currentGold + 15.50).toFixed(2), // تحديث الهاي بناءً على السعر الجديد
          goldLow: (currentGold - 12.30).toFixed(2),
          silver: currentSilver,
          silverHigh: (currentSilver + 0.80).toFixed(2),
          silverLow: (currentSilver - 0.50).toFixed(2),
          rates: r,
          forex: [
            { pair: "USD/EGP", val: r.EGP.toFixed(2), up: true },
            { pair: "EUR/USD", val: (1/r.EUR).toFixed(4), up: true },
            { pair: "GBP/USD", val: (1/r.GBP).toFixed(4), up: true },
            { pair: "USD/JPY", val: r.JPY.toFixed(2), up: false },
            { pair: "USD/SAR", val: r.SAR.toFixed(2), up: true },
            { pair: "USD/AED", val: r.AED.toFixed(2), up: true },
            { pair: "USD/KWD", val: r.KWD.toFixed(3), up: false },
            { pair: "USD/CAD", val: r.CAD.toFixed(3), up: true },
            { pair: "USD/INR", val: r.INR.toFixed(2), up: true },
            { pair: "USD/JOD", val: r.JOD.toFixed(3), up: false },
          ],
          change: "+1.25%", 
          amount: "$58.40"
        });
      }
    } catch (error) { console.error("API Fetch Error:", error); }
  };

  useEffect(() => {
    fetchPrices();
    const interval = setInterval(fetchPrices, 300000); 
    return () => clearInterval(interval);
  }, []);

  return prices;
};